import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';

class Footer extends React.Component {
  render() {
    return (
      <Container>
        <ContainerInner>
          <span>Copyright &copy; {new Date().getFullYear()} Observe Technologies.</span>
        </ContainerInner>
      </Container>
    );
  }
}

export default Footer;

const Container = styled.div`
  width: 100%;
  height: 60px;
  background: #262936;
  display: flex;
  color: rgb(102, 109, 137);
  /* justify-content: flex-end; */
  padding: 0 0.5rem;
`;

const ContainerInner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: 1200px;
  margin: 0 auto;
  text-align: right;
`;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js